import { useMemo, useState } from 'react';

import { useSpring, useReducedMotion } from '@react-spring/web';

export const SPRING_CONFIG_PRESS = { tension: 300, friction: 22 };
export const SPRING_CONFIG_RELEASE = { tension: 200, friction: 14 };

export const usePressState = () => {
  const [isPressed, setIsPressed] = useState(false);

  const pressHandlers = useMemo(
    () => ({
      onPointerDown: () => setIsPressed(true),
      onPointerUp: () => setIsPressed(false),
      onPointerLeave: () => setIsPressed(false),
      onPointerCancel: () => setIsPressed(false),
      onBlur: () => setIsPressed(false),
      onKeyDown: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          setIsPressed(true);
        }
      },
      onKeyUp: (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          setIsPressed(false);
        }
      },
    }),
    []
  );

  return { isPressed, pressHandlers };
};

export const usePressSpring = ({ scale = 0.85 } = {}) => {
  const { isPressed, pressHandlers } = usePressState();
  const prefersReducedMotion = useReducedMotion();

  const springStyle = useSpring({
    scale: isPressed ? scale : 1,
    config: isPressed ? SPRING_CONFIG_PRESS : SPRING_CONFIG_RELEASE,
    immediate: prefersReducedMotion,
  });

  return { isPressed, pressHandlers, springStyle };
};
